import { Grid } from "@cjdev-internal/visual-stack-x/Grid";
import React from "react";
import "./styles.css";

export const MetricsGrid = ({ children }) => (
  <Grid className="social-stats-grid" gap="large">
    {children}
  </Grid>
);
